<template>
    <div class="w3-display-container w3-center w3-margin w3-padding-64">
        <div class="w3-display-bottom-middle">
            <loading v-bind:dspin="true"></loading>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Loading from "./common/Loading";
    import il8n from '@/lang/lang'

    let frc = Vue.prototype.$frc;

    export default {
        name: "Loader",
        components: {Loading},
        mounted() {
            let app = this;
            if (!Vue.prototype.$currentUser) {
                frc.getCurrentUser().then(function (res) {
                    Vue.prototype.$currentUser = res.data.overview;
                });
            }
            const lang = Vue.prototype.$currentUser.language;
            if (lang) {
                console.log("Switching to user specific language: " + lang);
                il8n.locale = lang;
            }
            Vue.notifyInfo({
                title: "Welcome, " + Vue.prototype.$currentUser.firstName,
                message: "Language personalized to " + il8n.locale
            });
            app.$router.push("/");
            }
    }
</script>

<style scoped>

</style>